module.exports = __webpack_public_path__ + "static/media/21ECLAC18.7d5bbc22.jpg";